import axios from "@/libs/axios";

const endpointPrefix = process.env.VUE_APP_API_PREFIX;

export default {
  generateToken() {
    return axios.post(`/${endpointPrefix}/telegram/generate-token`);
  },
}